import React from 'react'
import './WhyHireUs.css'

import pd from '../../../../assets/img/project_delivered.svg'
import hc from '../../../../assets/img/happy_clients.svg'
import tc from '../../../../assets/img/coffee.svg'
import CountUpOnScroll from '../../Home/About/ScrollCounter'

function WhyHIreUs() {
  return (
    <section className='whu-sec'>
        <div className='container'>
            <div className='ffr-sec'>
                <div className='ffr-head'>
                    <h3>Founded on trust.</h3>
                    <h4>Focused on relationships.</h4>
                </div>
                <div className='ffr-desc'>
                    <p>We have a talented pool of developers, designers and strategists having  years of experience in handling complex and demanding app/solution  development projects for well-known brands and promising start-ups. We  have a highly streamlined and agile development process to ensure fast  paced execution and speedy time to market without compromising on  quality standard.</p>
                </div>
            </div>
            <div className='whu-sec1'>
                <div className='whulft'> {/*<img src={WhuImg} alt='' loading="lazy"/>*/}</div> 
                <div className='whurgt'>
                    <h3>Why hire us?</h3>
                    <ul>
                        <li>We are near you and meet in person to understand your needs.</li>
                        <li>We follow Agile Methods which maximize  our services designed for our Clients, drive productivity and efficiency  enabling dynamic Environment of quality codes.</li>
                        <li>We have extensive experience in mobile app technology, building apps for iOS & Android.</li>
                        <li>Our support system is flexible we follow necessary strategy, consulting with client about their needs and services.</li>
                        <li>Our clients have high success rates and returned back to us for more projects.</li>
                    </ul>
                </div>
                <div className='pht-sec'>
                    <ul>
                        <li><img src={pd} alt='Projects Delivered' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={ 200} />+</h4><p>Projects Delivered</p></li>
                        <li><img src={hc} alt='Happy Clients' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={300} />+</h4><p>Happy Clients</p></li>
                        <li><img src={tc} alt='Total Coffees' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={2500} />+</h4><p>Total Coffees</p></li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
  )
}

export default WhyHIreUs
